module.exports = __webpack_public_path__ + "img/share.ffb45d4f.png";